<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@lib/utils';
import { useVModel } from '@vueuse/core';

const props = withDefaults(
  defineProps<{
    defaultValue?: string | number;
    modelValue?: string | number;
    hasFloatLabel?: boolean;
    class?: HTMLAttributes['class'];
    error?: string;
    readonly?: boolean;
    disabled?: boolean;
  }>(),
  {
    hasFloatLabel: true,
    readonly: false,
    disabled: false,
  },
);

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <input
    v-model="modelValue"
    :disabled="disabled || readonly"
    :readonly="readonly"
    :class="
      cn(
        'flex h-10 w-full rounded-md border border-input/40 bg-foreground/20 px-3 py-1 text-sm text-white shadow-sm ring-0 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white/40 focus:border-input/100 focus:outline-none focus:ring-0 focus:ring-transparent',
        {
          'cursor-not-allowed': disabled || readonly,
          'opacity-50': disabled,
        },
        props.class,
        {
          'border-destructive': error?.length,
        },
        { peer: hasFloatLabel },
      )
    "
  />
  <!-- Above: Don't use inline styles -->
</template>
